import { Component, Input } from '@angular/core';
import { CommonModule } from '@angular/common';
import { ChargeState } from 'src/app/models/charge-state';
import { BatteryComponent } from '../../navigation-hud/battery/battery.component';
import { SvgRecolorDirective } from 'src/app/directives/svg-recolor.directive';
import { LanguageService } from 'src/app/services/account/language.service';

@Component({
  standalone: true,
  selector: 'app-navigation-plan-header',
  templateUrl: './navigation-plan-header.component.html',
  styleUrls: ['./navigation-plan-header.component.scss'],
  imports: [CommonModule, BatteryComponent, SvgRecolorDirective]
})
export class NavigationPlanHeaderComponent {
  @Input() estimatedBatteryLevel: number = 100;
  @Input() chargeState: ChargeState = ChargeState.None;
  @Input() chargerName: string = '';
  public ChargeState = ChargeState;

  constructor(public languageService: LanguageService) {}

  /** Short status label shown above the arrival message in the charge hero. */
  get heroEyebrow(): string {
    switch (this.chargeState) {
      case ChargeState.ArriveToCharger:
        return this.languageService.languageJSON?.VoiceCommand_Charge ?? '';
      case ChargeState.Charging:
        return this.languageService.languageJSON?.Global_Charging ?? '';
      case ChargeState.ChargeFinish:
        return this.languageService.languageJSON?.NavigationHud_ChargingIsFinished ?? '';
      default:
        return '';
    }
  }
}
